import { angularJsApp } from "../app";
import { AppComponentsEnum } from "../app.model";

class Component {
  isSearching = false;

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IScope,
  ) { }

  $onInit() {
    this.setupListeners();
  }

  private setupListeners() {
    this.$scope.$on('searchInit', () => {
      this.setOverlayValue(true);
    });

    this.$scope.$on('searchDone', () => {
      this.setOverlayValue(false);
    });

    this.$scope.$on('showOverlayLoader', () => {
      this.setOverlayValue(true);
    });

    this.$scope.$on('hideOverlayLoader', () => {
      this.setOverlayValue(false);
    });

    this.$scope.$on('error', () => {
      this.setOverlayValue(false);
    });

    this.$rootScope.$on('error', () => {
      this.setOverlayValue(false);
    });
  }

  setOverlayValue(value) {
    this.isSearching = value;
  }
}

const component: ng.IComponentOptions = {
  bindings: {},
  template: `
    <div id="overlay-loader" ng-if="$ctrl.isSearching">
      <div>
        <span class='fa fa-spinner fa-spin'></span>
      </div>
    </div>
  `,
  controller: Component,
};

angularJsApp.component(AppComponentsEnum.OVERLAY, component);
